import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';

export default function getMetaDescription(seoLocationDetails: SeoLocationDetails): string {
  if (seoLocationDetails && seoLocationDetails.seoMetaDescription !== '') {
    return seoLocationDetails.seoMetaDescription;
  }
  // The keyword sits mid-sentence, so it needs the sentence-cased form. An unauthored
  // keyword arrives as either null or "" — the columns are nullable and default to the
  // empty string — so both have to fall through to the title-cased keyword and then to
  // the legacy taxonomy that serviceTypeName carries, lowercased to fit the sentence.
  const serviceKeyword =
    seoLocationDetails.sentenceCasedServiceKeyword ||
    (
      seoLocationDetails.titleCasedServiceKeyword || seoLocationDetails.serviceTypeName
    ).toLowerCase();
  return `Find the best ${serviceKeyword} in ${seoLocationDetails.name} from our network of trusted local sitters. Pet parents in your area have booked on Rover and given their sitters 5-star reviews.`;
}
